import type { ApiResponse } from "@/features/auth/services/authApi";
import { apiClient } from "@/shared/services/api";

export type MpesaTransactionStatus = 1 | 2 | 3 | 4 | 5;

export const MpesaStatus = {
  Pending: 1,
  Success: 2,
  Failed: 3,
  Timeout: 4,
  Cancelled: 5,
} as const;

// 1=Pending, 2=Success, 3=Failed, 4=Timeout, 5=Cancelled
export const MPESA_STATUS_LABELS: Record<MpesaTransactionStatus, string> = {
  1: "Pending",
  2: "Success",
  3: "Failed",
  4: "Timed Out",
  5: "Cancelled",
};

export interface MpesaStkPushRequest {
  orderId: string;
  phoneNumber: string;
  amount: number;
}

export interface MpesaTransaction {
  id: string;
  orderId: string;
  phoneNumber: string;
  amount: number;
  checkoutRequestId: string;
  status: MpesaTransactionStatus;
  initiatedAt: string;
  completedAt?: string | null;
  resultDescription?: string | null;
  linkedPaymentId?: string | null;
  accountReference: string;
}

const unwrapResponse = <T>(data: ApiResponse<T> | T): T => {
  if (data && typeof data === "object" && "data" in (data as ApiResponse<T>)) {
    return (data as ApiResponse<T>).data;
  }
  return data as T;
};

export const mpesaApi = {
  initiateStkPush: async (payload: MpesaStkPushRequest): Promise<MpesaTransaction> => {
    const { data } = await apiClient.post<ApiResponse<MpesaTransaction> | MpesaTransaction>(
      "/mpesa/stk-push",
      payload
    );
    return unwrapResponse<MpesaTransaction>(data);
  },

  getRequest: async (id: string): Promise<MpesaTransaction> => {
    const { data } = await apiClient.get<ApiResponse<MpesaTransaction> | MpesaTransaction>(
      `/mpesa/requests/${id}`
    );
    return unwrapResponse<MpesaTransaction>(data);
  },
};
